import { NgClass, NgIf } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';

import { isAssetOnboardingRoute } from '../../Helper/common-utils';
import { LayoutViewServiceService } from '../../services/layout-view-service.service';
import { ContractTransactionsComponent } from '../contract-transactions/contract-transactions.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
    selector: 'app-feature-layout',
    templateUrl: './feature-layout.component.html',
    styleUrls: ['./feature-layout.component.css'],
    imports: [SidebarComponent, ContractTransactionsComponent, RouterOutlet, NgIf, NgClass]
})
export class FeatureLayoutComponent implements OnInit {

    constructor(private layoutView: LayoutViewServiceService, private router: Router) {}
    isView: boolean = false;

    /**
     * The asset onboarding flow runs full-width: it is a focused, multi-screen form, and the
     * nav rail beside it is both a distraction and a way to lose a half-filled deposit. The
     * header already hides its nav on these routes (`isAssetOnboardingRoute`) — this is the
     * same decision applied to the rail.
     */
    hideSidebar = false;

    private readonly destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        // Read the current URL first: the layout is created by the navigation that lands on
        // the deposit page, so its NavigationEnd may already have passed.
        this.hideSidebar = isAssetOnboardingRoute(this.router.url);

        this.router.events
            .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef))
            .subscribe((event) => {
                this.hideSidebar = isAssetOnboardingRoute(event.urlAfterRedirects || event.url);
            });

        this.layoutView.isView$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
            this.isView = value;
        });
    }

}
